import React from 'react';

interface Props {
  color?: string;
  fontSize?: number | string;
}

const Eye: React.FC<Props> = ({ color = 'inherit', fontSize = 'inherit' }) => {
  return (
    <svg
      role="img"
      width="1em"
      height="1em"
      style={{ fontSize: typeof fontSize === 'string' ? fontSize : `${fontSize}px`, color }}
      viewBox="0 0 20.192 20"
    >
      <g id="Component_769_1" data-name="Component 769 – 1" transform="translate(0.022)">
        <g
          id="Rectangle_1418"
          data-name="Rectangle 1418"
          fill="currentColor"
          stroke="#707070"
          strokeWidth="1"
          opacity="0"
        >
          <rect width="20" height="20" stroke="none" />
          <rect x="0.5" y="0.5" width="19" height="19" fill="none" />
        </g>
        <g id="Icon_feather-eye" data-name="Icon feather-eye" transform="translate(-0.684 -2.861)">
          <path
            id="Path_5921"
            data-name="Path 5921"
            d="M1.5,12.733S4.866,6,10.757,6s9.257,6.733,9.257,6.733-3.366,6.733-9.257,6.733S1.5,12.733,1.5,12.733Z"
            transform="translate(0 0)"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            id="Path_5922"
            data-name="Path 5922"
            d="M18.549,16.025A2.525,2.525,0,1,1,16.025,13.5,2.525,2.525,0,0,1,18.549,16.025Z"
            transform="translate(-5.267 -3.292)"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  );
};

export default Eye;
